<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">{{ $t('library.category') }}</label>
                <v-select class="w-full" v-model="selectedCategory" :options="categoryOptions"
                          :reduce="option => option.value">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>

            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">{{ $t('onMap.search') }}</label>
                <vs-input class="w-full" v-model="keySearch" placeholder="Tìm kiếm theo tên sách ..."></vs-input>
            </div>
            <div class="vx-col lg:w-1/2 w-full flex sm:mt-0 mt-4">
                <vs-button class="mt-6" icon-pack="feather" icon="icon-search" @click="filter">{{ $t('onMap.search') }}</vs-button>
                <vs-button class="mt-6 ml-auto" icon-pack="feather" icon="icon-plus" @click="addBook" type="border">
                    {{ $t('button.add') }}
                </vs-button>
            </div>
        </div>

        <!-- AgGrid Table -->
        <ag-grid-vue style="height: 55vh"
                     ref="agGridTable"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="bookData"
                     :animateRows="true"
                     paginationPageSize="20"
                     :pagination="true"
                     @pagination-changed="onPaginationChanged"
                     @grid-ready="onGridReady"
                     :localeText="{noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                     :autoSizeStrategy="autoSizeStrategy"
                     tooltipShowDelay="0"
                     tooltipHideDelay="5000"
                     :tooltipMouseTrack="true">
        </ag-grid-vue>

        <div class="vx-row" v-if="bookData && bookData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">{{ $t('dashboard.NumberOfElementsPage') }}:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        bookData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : bookData.length
                                    }} /
                                    {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @input="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import vSelect from 'vue-select';
import CellRendererActionsBook from './cell-renderer/CellRendererActionsBook';
import moment from "moment";

export default {
    name: "ManageBook",
    components: {
        AgGridVue,
        vSelect,
        CellRendererActionsBook,
    },

    data() {
        return {
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('library.stt'),
                    field: 'stt',
                    width: 150,
                },
                {
                    headerName: this.$t('library.bookTitle'),
                    field: 'title',
                    width: 180
                },
                {
                    headerName: this.$t('library.downloadCount'),
                    field: 'downloadCount',
                    width: 150,
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDateStr',
                    width: 150,
                },
                {
                    headerName: this.$t('menuOrganization.modifiedDate'),
                    field: 'modifiedDateStr',
                    width: 150,
                },
                {
                    headerName: this.$t('library.actions'),
                    field: 'actions',
                    width: 200,
                    cellRenderer: 'CellRendererActionsBook',
                    suppressSizeToFit: true,
                },
            ],

            pageNumber: 0,
            pageSize: 30,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            keySearch: null,
            bookData: [],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            categoryOptions: [],
            selectedCategory: 'null',
        }
    },

    watch: {
        '$store.state.isUpdateBook'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_BOOK', false);
            }
        }
    },

    async created() {
        await this.getCategory();
        this.getBook();
    },

    methods: {
        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },

        loadPage: function (currentPage) {
            this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
            this.getBook();
        },

        changePageSize(number) {
            this.pageSize = number;
            this.filter();
        },

        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getBook();
        },

        getBook() {
            let payload = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                title: this.keySearch,
                categoryId: JSON.parse(this.selectedCategory),
            }

            this.$vs.loading();
            this.$crm.post('/library/item/find-by-condition', payload).then(res => {
                this.$vs.loading.close();
                if (res.data.content && res.data.content.length > 0) {
                    this.bookData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.createdDateStr = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY') : null;
                        el.modifiedDateStr = el.modifiedDate ? moment(el.modifiedDate).format('DD/MM/YYYY') : null;
                        return el;
                    });
                } else {
                    this.bookData = [];
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        addBook() {
            this.$router.push('/user/details-book').catch(() => {
            });
        },

        getCategory() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post('/library/category/find-by-condition', {}).then(res => {
                    this.$vs.loading.close();
                    resolve(res);
                    if (res.data.content && res.data.content.length > 0) {
                        this.categoryOptions = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.title
                            }
                        })
                        this.categoryOptions.unshift({value: 'null', label: 'Tất cả'});
                    } else {
                        this.categoryOptions = [];
                    }
                    this.totalElementCategory = res.data.totalElements;
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },
}
</script>

<style scoped>

</style>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>


